import { createGlobalStyle } from 'styled-components'
import styledNormalize from 'styled-normalize'

import fonts from './fonts'
import scaffolding from './scaffolding'
import { getTheme, helpers } from './theme'
import types from './types'

export type { Theme } from './theme'

export { getTheme, helpers }

export const GlobalStyle = createGlobalStyle`
	${fonts}
	${styledNormalize}
	${scaffolding}
	${types}

	h1,
	h2,
	h3,
	h4,
	h5 {
		margin: 2.75rem 0 1.05rem;
		line-height: 1.15;
		color: ${helpers.color.textHeader};
	}

	*::-webkit-scrollbar {
		background-color: transparent;
		width: 6px;
		height: 6px;
	}

	*::-webkit-scrollbar-thumb {
		background-color: ${helpers.color.scrollbarThumb};
		border-radius: 6px;
		border: none;
	}

	::-webkit-scrollbar-corner {
		background-color: transparent;
	}

	::selection {
		color: ${helpers.color.textHeader};
		background-color: ${helpers.color.textSelect};
	}
`
